/* eslint-disable import/prefer-default-export */
export const eventListingsURL = '/selfservice/event-listings';

export const eventListingsScreens = [
  { name: 'Contact', path: 'contact' },
  { name: 'Create', path: 'details' },
  { name: 'Checkout', path: 'checkout' },
  { name: 'Confirmation', path: 'confirmation' },
];
export const eventListingsCreateBreadcrumbs = eventListingsScreens.filter((screen) => screen.path !== 'confirmation');

export const eventListingsEditBreadcrumbs = [
  { name: 'Edit Contact', path: 'contact' },
  { name: 'Manage', path: 'details' },
];

export const confirmationScreenArticles = [
  {
    key: 'increase-event-registrations',
    imgSrc: 'https://assets.studioid.com/images/Zz1jNjU2ZTBhYWMyNzMxMWVkODM0MGVhZGIxMzBmYjkyYw==?width=1000&height=670',
    articleTitle: '11 Surefire Ways to Increase Event Registrations',
    articleUrl: 'https://www.studioid.com/springboard/how-to/10-surefire-ways-to-increase-event-registrations/',
  },
  {
    key: 'experience-led-growth',
    imgSrc: 'https://assets.studioid.com/images/Zz1iMmYwMzE2MmQwMDMxMWVlOTA4ZTY2Y2RiMWY0MTRmMg==?width=1000&height=670',
    articleTitle: 'B2B Leaders, Here\'s How to Capitalize on Experience-Led Growth',
    articleUrl: 'https://www.studioid.com/springboard/pov/b2b-leaders-heres-how-to-capitalize-on-experience-led-growth/',
  },
  {
    key: 'convert-event-leads',
    imgSrc: 'https://assets.studioid.com/images/Zz0xMzJjOWZkYWMzNDMxMWVkYjViYTU2N2Y2ZTAxZmYzMA==?width=1000&height=670',
    articleTitle: 'After the Event: 4 Tactics to Convert Event Leads into Clients',
    articleUrl: 'https://www.studioid.com/springboard/how-to/after-the-event-4-tactics-to-convert-event-leads-into-clients/',
  },
];
